import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/PrintingActions";
import {loadPrintJobs} from "../helper functions/LoadPrintJobs";

export function PrintFullList() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const dispatch = useDispatch()
    let sort = useSelector(state => state.printSortFull);
    let search = useSelector(state => state.printSearchFull);
    const [loading, setLoading] = useState(true);

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>All print jobs</h1>
                    <p>A list of all print jobs</p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => {
                            dispatch(actions.SortNew("COMPLETE"))
                        }}>Newest First </a>
                        <a onClick={sort => dispatch(actions.SortOld("COMPLETE"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("COMPLETE"))}> A-Z </a>
                    </div>
                </div>

                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.fullSearch(document.getElementById("search-input").value, "COMPLETE"))}> 🔍
                    </button>
                </div>

                <div className="page-break"></div>
                <br/>

                <div>
                    {loadPrintJobs(sort, search)}
                </div>

                <div className="page-break"></div>
            </AuthenticatedTemplate>
        </div>
    );
}
